// Keys that are per-user preferences rather than session data, and so survive
// logout / an expired session. Lead pipeline filters are already scoped by user
// id, and are only removed by the filter bar's "Clear" button.
const PRESERVED_KEY_PREFIXES = ["leadPipelineFilters:"];

// Raw Storage methods: localStorage.getItem/setItem are replaced by
// services/localStorageSecurity (encrypt on write, decrypt + JSON.parse on read),
// so preserved entries are copied as their stored (encrypted) strings, untouched.
const rawGet = (key) => Storage.prototype.getItem.call(localStorage, key);
const rawSet = (key, value) => Storage.prototype.setItem.call(localStorage, key, value);

// Clears the login session from localStorage, keeping saved preferences
export const clearSession = () => {
  const kept = Object.keys(localStorage)
    .filter((key) => PRESERVED_KEY_PREFIXES.some((prefix) => key.startsWith(prefix)))
    .map((key) => [key, rawGet(key)]);
  localStorage.clear();
  kept.forEach(([key, value]) => rawSet(key, value));
};
